import { render, staticRenderFns } from "./CreateComponent.vue?vue&type=template&id=36edaab8&"
import script from "./CreateComponent.vue?vue&type=script&lang=ts&"
export * from "./CreateComponent.vue?vue&type=script&lang=ts&"
import style0 from "./CreateComponent.vue?vue&type=style&index=0&id=36edaab8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports